import * as React from "react"
import LogoText from "../images/arcaneText.svg"

const Header = ({ siteTitle }) => (
  <nav>
    <img alt="Arcane Wraps" src={LogoText}/>
  </nav>
)

export default Header